<template>
  <div>
    <HeaderView :title="$t('mine.recharge')" />
    <div class="view-page">
      <div class="top">
        <div class="avatar">
          <van-image
            round
            width="4.2rem"
            height="4.2rem"
            :src="userInfo.header_img"
          />
          <div class="me">
            <div
              class="user"
              style="flex-direction: initial; align-items: center"
            >
              <p style="padding-bottom: 0px">{{ userInfo.username }}</p>
            </div>
            <div class="ps">
              <span
                style="padding-left: 0px; margin: 14px 0px 2px; font-size: 15px"
                >{{ $t("recharge.point") }}:{{ userInfo.amount_code }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="msg-box">
        <div class="icon">
            <img src="../../assets/img/mine/kf.png" />
        </div>
        <div class="text">
            {{ $t('recharge.remark') }}
        </div>
        <div style="clear: both;" />
      </div>
      <div style="margin: 16px;">
        <van-button @click="$router.push({name:'service'})" class="btn">{{
        $t("recharge.toserve")
      }}</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderView from "@/components/Header/index.vue";
export default {
  name: "RechargeView",
  components: { HeaderView },
  data() {
    return {
      userInfo: {},
    };
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          console.log(this.userInfo);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.top {
  width: 100%;
  background: linear-gradient(41deg, #7d76ef, #e3549d 90%);
  padding: 2.5rem 5% 2.5rem;
  .avatar {
    width: 80%;
    padding: 0 6%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 1rem;
    .me {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      padding-left: 1.33333rem;
      flex: 1;
      .user {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        p {
          font-size: 1rem;
          color: #fff;
          padding-bottom: 0.33333rem;
        }
      }
      .ps {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        span {
          padding-left: 0.33333rem;
          color: #ffe0f6;
          font-size: 0.73333rem;
        }
      }
      .proess {
        width: 40%;
        height: 0.26667rem;
        background: #e5d3cb;
        margin: 0.46667rem 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border-radius: 0.66667rem;
        overflow: hidden;
        span {
          background: #fff;
          height: 100%;
          width: 50%;
        }
      }
    }
  }
}
.msg-box{
    background-color: #f2f2f5;
    padding: 15px 10px;
    width: 90%;
    margin: 20px auto;
    border-radius: 75px;
    height: 95px;
    .icon {
        float: left;
        width: 48px;
        img {
            width:100%;
            height: auto;
            margin-top: 22px;
        }
    }
    .text{
        float: left;
        color: #390f86;
        width: calc(100% - 58px);
        margin-left: 10px;
    }
}
</style>
